import { Pagination } from '@store/common/pagination.model';

export interface WastePagination extends Pagination {
  data: Waste[];
}

export type ManageWaste = Partial<Waste>

export interface Waste {
  id: number;
  name: string;
  density: number;
  code: string;
  co2emission?: number;
  wasteFamilyName: string;
  wasteFamilyId: WasteFamily['id'];
  nameTranslateKey: string;
  createAt: Date;
  datahubSpecId: number;
  updatedAt: Date;
  family: WasteFamily;
}

export interface WasteFamiliesPagination extends Pagination {
  data: WasteFamily[];
}

export type ManageWasteFamily = Partial<Omit<WasteFamily, 'waste'>>

export interface WasteFamily {
  id: number;
  name: string;
  marketPriceInCents: number;
  waste: Array<Waste['id']>;
  nameTranslateKey: string;
  iconPath: string;
  estimatedKilometersForProcessing: number;
  valorisationType : ValorisationType;
}

export enum ValorisationType {
  MATERIAL = 'MATERIAL',
  ENERGY = 'ENERGY',
}